module.exports = __webpack_public_path__ + "assets/img/client-logo-lsh-mono.056349e6.png";